import Preload from "@frog/source/engine/Preload.js"

const imagePaths = {
    "dungeonwalls": require("@frog/source/assets/images/dungeon-tactics/tiles/dungeoncorners.png"),
    "sand": require("@frog/source/assets/images/dungeon-tactics/tiles/sand.png"),
    "tree": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png"),
    "house": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/house.png"),
    "mountain": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/mountain_1.png"),
    "fort": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/fort_red.png"),
    "cactus": require("@frog/source/assets/images/hero-tactics/map/desert/objects/cactus_1.png"),
    "rocks": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_1.png"),
    "boulder": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_2.png"),
    "stone": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_3.png"),
    "obelisk": require("@frog/source/assets/images/hero-tactics/map/desert/objects/obelisk.png"),
    "tent": require("@frog/source/assets/images/hero-tactics/map/desert/objects/tent_blue.png"),
    "bones": require("@frog/source/assets/images/hero-tactics/map/desert/objects/bones_1.png"),
}

const tileset = {
    "collision": {
        "key": "collision",
        "drawOrder": 100,
        "channelKey": "collision",
        "tint": {
            "r": 200,
            "g": 100,
            "b": 100,
        },
        "isSecret": true,
    },
    "not-found": {
        "key": "not-found",
        "drawOrder": 1,
        "tint": {
            "r": 27,
            "g": 31,
            "b": 39,
        },
    },
    "hero/grass": {
        "key": "hero/grass",
        "equivalentGIDs": [12, 13],
        "drawOrder": 1,
        "tint": {
            "r": 204,
            "g": 195,
            "b": 94,
        }, // hex: CCC35E
        "checkerColor": {
            "r": 218,
            "g": 212,
            "b": 94,
        }, // hex: DAD45E
        "channelKey": "floor",
    },
    "hero/sand": {
        "key": "hero/sand",
        "equivalentGIDs": [7, 8],
        "drawOrder": 1,
        "tint": {
            "r": 224,
            "g": 164,
            "b": 100,
        }, // hex: E0A464
        "checkerColor": {
            "r": 231,
            "g": 146,
            "b": 75,
        }, // hex: E7924B
        "channelKey": "floor",
    },
    "hero/path": {
        "key": "hero/path",
        "equivalentGIDs": [35, 36, 40, 41, 45, 46],
        "tilespread": {"images": {
            "0": require("@frog/source/assets/images/tool-kit/road/0.png"),
            "1": require("@frog/source/assets/images/tool-kit/road/n.png"),
            "2": require("@frog/source/assets/images/tool-kit/road/e.png"),
            "3": require("@frog/source/assets/images/tool-kit/road/ne.png"),
            "4": require("@frog/source/assets/images/tool-kit/road/s.png"),
            "5": require("@frog/source/assets/images/tool-kit/road/ns.png"),
            "6": require("@frog/source/assets/images/tool-kit/road/se.png"),
            "7": require("@frog/source/assets/images/tool-kit/road/nse.png"),
            "8": require("@frog/source/assets/images/tool-kit/road/w.png"),
            "9": require("@frog/source/assets/images/tool-kit/road/nw.png"),
            "10": require("@frog/source/assets/images/tool-kit/road/ew.png"),
            "11": require("@frog/source/assets/images/tool-kit/road/new.png"),
            "12": require("@frog/source/assets/images/tool-kit/road/sw.png"),
            "13": require("@frog/source/assets/images/tool-kit/road/nsw.png"),
            "14": require("@frog/source/assets/images/tool-kit/road/sew.png"),
            "15": require("@frog/source/assets/images/tool-kit/road/nsew.png"),
        }},
        "tilespreadType": "edge-match",
        "drawOrder": 4,
        "channelKey": "paving",
    },
    "hero/river": {
        "key": "hero/river",
        "tilespread": {"images": {
            "0": require("@frog/source/assets/images/tool-kit/river/0.png"),
            "1": require("@frog/source/assets/images/tool-kit/river/n.png"),
            "2": require("@frog/source/assets/images/tool-kit/river/e.png"),
            "3": require("@frog/source/assets/images/tool-kit/river/ne.png"),
            "4": require("@frog/source/assets/images/tool-kit/river/s.png"),
            "5": require("@frog/source/assets/images/tool-kit/river/ns.png"),
            "6": require("@frog/source/assets/images/tool-kit/river/se.png"),
            "7": require("@frog/source/assets/images/tool-kit/river/nse.png"),
            "8": require("@frog/source/assets/images/tool-kit/river/w.png"),
            "9": require("@frog/source/assets/images/tool-kit/river/nw.png"),
            "10": require("@frog/source/assets/images/tool-kit/river/ew.png"),
            "11": require("@frog/source/assets/images/tool-kit/river/new.png"),
            "12": require("@frog/source/assets/images/tool-kit/river/sw.png"),
            "13": require("@frog/source/assets/images/tool-kit/river/nsw.png"),
            "14": require("@frog/source/assets/images/tool-kit/river/sew.png"),
            "15": require("@frog/source/assets/images/tool-kit/river/nsew.png"),
        }},
        "tilespreadType": "edge-match",
        "drawOrder": 3,
        "channelKey": "water",
    },
    "hero/water": {
        "key": "hero/water",
        "equivalentGIDs": [75, 76, 77, 78, 79, 80, 83, 84, 85, 86, 87], // rounds-up the lake size to the nearest corner
        //"equivalentGIDs": [83], // rounds-down the lake size to the nearest corner
        "tilespread": {"images": {
            "1": require("@frog/source/assets/images/tool-kit/lake/nw.png"),
            "2": require("@frog/source/assets/images/tool-kit/lake/ne.png"),
            "3": require("@frog/source/assets/images/tool-kit/lake/nwne.png"),
            "4": require("@frog/source/assets/images/tool-kit/lake/se.png"),
            "5": require("@frog/source/assets/images/tool-kit/lake/nwse.png"),
            "6": require("@frog/source/assets/images/tool-kit/lake/nese.png"),
            "7": require("@frog/source/assets/images/tool-kit/lake/nwnese.png"),
            "8": require("@frog/source/assets/images/tool-kit/lake/sw.png"),
            "9": require("@frog/source/assets/images/tool-kit/lake/nwsw.png"),
            "10": require("@frog/source/assets/images/tool-kit/lake/nesw.png"),
            "11": require("@frog/source/assets/images/tool-kit/lake/nwnesw.png"),
            "12": require("@frog/source/assets/images/tool-kit/lake/sesw.png"),
            "13": require("@frog/source/assets/images/tool-kit/lake/nwsesw.png"),
            "14": require("@frog/source/assets/images/tool-kit/lake/nesesw.png"),
            "15": require("@frog/source/assets/images/tool-kit/lake/nwnesesw.png"),
        }},
        "tilespreadType": "corner-match",
        "grid": "corner",
        "drawOrder": 2,
        "channelKey": "water",
    },
    "hero/tree": {
        "key": "hero/tree",
        "equivalentGIDs": [64, 65],
        "drawOrder": 100,
        "tilespread": imagePaths["tree"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/house": {
        "key": "hero/house",
        "drawOrder": 100,
        "tilespread": imagePaths["house"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/mountain": {
        "key": "hero/mountain",
        "drawOrder": 100,
        "tilespread": imagePaths["mountain"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/fort": {
        "key": "hero/fort",
        "equivalentGIDs": [59],
        "drawOrder": 100,
        "tilespread": imagePaths["fort"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/rocks": {
        "key": "hero/rocks",
        "equivalentGIDs": [70],
        "drawOrder": 100,
        "tilespread": imagePaths["rocks"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/cactus": {
        "key": "hero/cactus",
        "equivalentGIDs": [68, 69],
        "drawOrder": 100,
        "tilespread": imagePaths["cactus"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/obelisk": {
        "key": "hero/obelisk",
        "drawOrder": 100,
        "tilespread": imagePaths["obelisk"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/tent": {
        "key": "hero/tent",
        "equivalentGIDs": [74],
        "drawOrder": 100,
        "tilespread": imagePaths["tent"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/bones": {
        "key": "hero/bones",
        "equivalentGIDs": [66],
        "drawOrder": 100,
        "tilespread": imagePaths["bones"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
        "channelKey": "decor",
    },
    "planks": {
        "key": "planks",
        "equivalentGIDs": [1, 16],
        "tileType": 16,
        "drawOrder": 5,
        "tint": {
            "r": 160,
            "g": 90,
            "b": 60,
        },
        "isGridded": true,
        "channelKey": "floor",
    },
    "checker": {
        "key": "checker",
        "drawOrder": 10,

        "layerString": "board",
        "layerEffect": "multiply",

        "tint": {
            "r": 200,
            "g": 200,
            "b": 200,
        },
        "isAlternatingChecker": true,
        "grid": "face",
        "channelKey": "board",
    },
    "shade": {
        "key": "shade",
        "drawOrder": 100,

        "layerString": "shading",
        "layerEffect": "multiply",

        "tint": {
            "r": 100,
            "g": 100,
            "b": 150,
        },
        "grid": "face",
        "channelKey": "lighting",
    },
    "blob-shade": {
        "key": "blob-shade",
        "drawOrder": 100,

        "layerString": "shading",
        "layerEffect": "multiply",

        "tilespread": require("@frog/source/assets/images/tool-kit/shade.png"),
        "tilespreadType": "corner-continuous",
        "grid": "corner",
        "tileSize": 96,
        "channelKey": "lighting",
    },
    "tree-shade": {
        "key": "tree-shade",
        "drawOrder": 100,

        "layerString": "shading",
        "layerEffect": "multiply",

        "tilespread": require("@frog/source/assets/images/tool-kit/tree-shade.png"),
        "tilespreadType": "corner-continuous",
        "grid": "corner",
        "tileSize": 96,
        "channelKey": "lighting",
    },
    "lightpool": {
        "key": "lightpool",
        "drawOrder": 200,

        "layerString": "light",
        "layerEffect": "screen",

        "tilespread": require("@frog/source/assets/images/tool-kit/shade.png"),
        "tilespreadType": "corner-continuous",
        "grid": "corner",
        "tileSize": 96,
        "channelKey": "lighting",
    },
    "sand": {
        "key": "sand",
        "drawOrder": 1,
        "tilespread": imagePaths["sand"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "tileSize": 128,
        "channelKey": "floor",
    },
    "redwall": {
        "key": "redwall",
        "tilespread": imagePaths["dungeonwalls"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "gradientSwap": [
            {
                "r": 1,
                "g": 1,
                "b": 30
            },
            {
                "r": 248,
                "g": 120,
                "b": 128,
            },
        ],
        "tileSize": 96,
        "drawOrder": 20,
    },
    "wall": {
        "key": "wall",
        "tilespread": imagePaths["dungeonwalls"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "tileSize": 96,
        "drawOrder": 20,
    },
}

const images = {}
Object.keys(tileset).forEach((key) => {
    const tilesetting = tileset[key]
    if(tilesetting.tilespread == undefined) return
    if(tilesetting.tilespread.images != undefined) {
        Object.keys(tilesetting.tilespread.images).forEach((imageKey) => {
            images[key + imageKey] = {
                "key": key + imageKey,
                "url": tilesetting.tilespread.images[imageKey],
                "callback": (image) => {
                    if(tilesetting.images == undefined) tilesetting.images = {}
                    tilesetting.images[imageKey] = image.element
                    //tilesetting.defaultColors = getPalette(image.element)
                },
            }
        })
        return
    }
    images[key] = {
        "key": key,
        "url": tilesetting.tilespread,
        "callback": (image) => {
            tilesetting.image = image.element
            //tilesetting.defaultColors = getPalette(image.element)
        },
    }
})
const preload = new Preload({
    "images": images
})

export {preload, tileset}
